{
  "expandButtonClose": "Vis mer",
  "expandButtonOpen": "Vis mindre"
}
